<div class="notificationHeader notificationSection">
  <button (click)="onClose()"><mat-icon>arrow_right_alt</mat-icon></button>
  <h2>Notification</h2>
  <div class="count count--{{ notificationService.totalNewCount$ | async }}">
    {{ notificationService.totalNewCount$ | async }}
  </div>
</div>
<div class="notificationSection">
  <div class="dateRangeTitle">
    <h3>Today</h3>
    <div class="lineSpace"></div>
  </div>
  <mat-list class="notificationList">
    <mat-list-item *ngFor="let notification of notificationService.todayNotifications$ | async">
      <div class="notification">
        <div class="notification__readStatus" [ngClass]="{ read: notification.status === 'Read' }"></div>
        <div class="notification__info">
          <p class="notification__body">
            {{ notification.body }}
          </p>
          <p class="notification__type">
            {{ notification.type }}
          </p>
        </div>
        <div class="notification__date">
          <p>
            {{ notification.createdDate | date: 'MM/dd/yyyy' }}
          </p>
        </div>
      </div>
    </mat-list-item>
  </mat-list>
</div>
<div class="notificationSection">
  <div class="dateRangeTitle">
    <h3>Yesterday</h3>
    <div class="lineSpace"></div>
  </div>
  <mat-list class="notificationList">
    <mat-list-item *ngFor="let notification of notificationService.yesterdayNotifications$ | async">
      <div class="notification">
        <div class="notification__readStatus" [ngClass]="{ read: notification.status === 'Read' }"></div>
        <div class="notification__info">
          <p class="notification__body">
            {{ notification.body }}
          </p>
          <p class="notification__type">
            {{ notification.type }}
          </p>
        </div>
        <div class="notification__date">
          <p>
            {{ notification.createdDate | date: 'MM/dd/yyyy' }}
          </p>
        </div>
      </div>
    </mat-list-item>
  </mat-list>
</div>
<div class="notificationSection">
  <div class="dateRangeTitle">
    <h3>More</h3>
    <div class="lineSpace"></div>
  </div>

  <mat-list class="notificationList">
    <mat-list-item *ngFor="let notification of notificationService.moreNotifications$ | async">
      <div class="notification">
        <div class="notification__readStatus" [ngClass]="{ read: notification.status === 'Read' }"></div>
        <div class="notification__info">
          <p class="notification__body">
            {{ notification.body }}
          </p>
          <p class="notification__type">
            {{ notification.type }}
          </p>
        </div>
        <div class="notification__date">
          <p>
            {{ notification.createdDate | date: 'MM/dd/yyyy' }}
          </p>
        </div>
      </div>
    </mat-list-item>
  </mat-list>
</div>
